<template>
  <div class="ai-friend-transaction">
    <ConfigTable ref="ct" :searchConfig="searchConfig" :tableColumns="tableColumns" :tableData="list" :total="total"
      @change="loadData"></ConfigTable>
  </div>
</template>

<script>
import { changeDate } from '../../../utils/filter';
import ConfigTable from '@/components/config-table';
import aiFriendApi from '../../../api/aiFriendManage';
import { appOptions, getLabelTextWithValue, tranTypeOptions } from '../../config';

const searchConfig = [
  { type: 'select', placeholder: '选择App', key: 'appId', options: appOptions },
  { type: 'input', placeholder: '流水ID搜索', key: 'id' },
  { type: 'input', placeholder: '消息ID搜索', key: 'messageId' },
  { type: 'input', placeholder: '用户ID搜索', key: 'userId' },
  { type: 'input', placeholder: '用户唯一ID搜索', key: 'uniqueId' },
  { type: 'select', placeholder: '选择交易类型搜索', key: 'tranTypeInt', options: tranTypeOptions },
  { type: 'button', icon: 'search', placeholder: '搜索', key: 'search' },
]
// 积分流水这里
// PromptUsdt       float64            json:"promptUsdt" bson:"promptUsdt"             // 提示词扣费USDT
// CompletionUsdt   float64            json:"completionUsdt" bson:"completionUsdt"     // 完成词扣费USDT
// TotalUsdt        float64            json:"totalUsdt" bson:"totalUsdt"               // 总扣费USDT
// PromptCost       float64            json:"promptCost" bson:"promptCost"             // 提示词成本USDT
// CompletionCost   float64            json:"completionCost" bson:"completionCost"     // 完成词成本USDT
// TotalCost        float64            json:"totalCost" bson:"totalCost"               // 总成本USDT
const tableColumns = [
  { name: 'ID', key: 'id', width: 220, fixed: 'fixed' },
  { name: '消息ID', key: 'messageId', width: 220 },
  { name: '应用', key: 'appId', width: 100, valueHandler: (val) => getLabelTextWithValue(appOptions, val) },
  { name: '模型名称', key: 'modelName', width: 160 },
  { name: '用户ID', key: 'userId', width: 100 },
  // { name: '业务ID', key: 'businessId' },
  { name: '交易类型', key: 'tranType' },
  // { name: '余额', key: 'currentBalance', width: 100 },
  { name: '提示词消耗（积分）', key: 'promptAmount', width: 160 },
  { name: '完成词消耗（积分）', key: 'completionAmount', width: 160 },
  { name: '总消耗（积分）', key: 'amount', width: 160 },
  { name: '提示词扣费（USDT）', key: 'promptUsdt', width: 160 },
  { name: '完成词扣费（USDT）', key: 'completionUsdt', width: 160 },
  { name: '总扣费（USDT）', key: 'totalUsdt', width: 160 },
  { name: '提示词成本（USDT）', key: 'promptCost', width: 160 },
  { name: '完成词成本（USDT）', key: 'completionCost', width: 160 },
  { name: '总成本（USDT）', key: 'totalCost', width: 160 },
  { name: '备注', key: 'remark', width: 250 },
  {
    name: '创建时间', key: 'createdAt', valueHandler: changeDate
  },
  // { name: '操作', fixed: 'right', actions: ['edit', 'delete'] },
];

export default {
  name: 'AiFriendTransactionList',
  components: { ConfigTable },
  data() {
    return {
      searchConfig,
      tableColumns,
      total: 0,
      list: [],
    };
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    async loadData(params) {
      try {
        const r = await aiFriendApi.getAiTransactionList(params)
        const data = r.data
        this.total = data.total
        this.list = data.list
      } catch (error) {
        console.error('搜索ai女友聊天记录失败：', error);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.ai-friend-transaction {

  /deep/ .el-button {
    padding: 9px 15px;
  }
}
</style>